import { createSelector } from 'reselect';
import { professionAdditionalEducationSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const professionAdditionalEducationYearsSelector = createSelector(
  [professionAdditionalEducationSelector],
  (professionAdditionalEducation) =>
    extractDatesFromNestedItems(
      [professionAdditionalEducation.content],
      [
        {
          type: 'date',
          field: 'eventDate',
        },
      ],
    ),
);
